import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  let navigate = useNavigate();
  const [input, setInput] = useState({
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleLogin = (event) => {
    event.preventDefault();

    let { email, password } = input;

    if (password.length >= 8) {
      axios
        .post(`https://dev-example.sanbercloud.com/api/login`, {
          email,
          password,
        })
        .then((res) => {
          // console.log(res);
          let data = res.data;
          let { token, user } = data;
          Cookies.set("token", token, { expires: 1 });
          Cookies.set("user", JSON.stringify(user), { expires: 1 });
          navigate("/dashboard");
        })
        .catch((err) => {
          console.log(err);
          alert("Email atau Password salah");
        });
    } else {
      alert("Password minimal 8 karakter");
    }
  };

  console.log(input);
  return (
    <React.Fragment>
      <section className="h-screen">
        <div className="container px-6 py-12 h-full">
          <div className="flex justify-center items-center flex-wrap h-full g-6 text-gray-800">
            <div className="md:w-8/12 lg:w-6/12 mb-12 md:mb-0">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg"
                className="w-full"
                alt="Phone"
              />
            </div>
            <div className="md:w-8/12 lg:w-5/12 lg:ml-20">
              <p className="sm:w-full xl:w-1/2 m-2 p-2 bg-cyan-500 text-white rounded-lg self-center whitespace-nowrap text-xl font-semibold dark:text-white">
                YPU (Yang Penting Usaha)
              </p>
              <form onSubmit={handleLogin}>
                {/* Email input */}
                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    value={input.email}
                    name="email"
                    type="text"
                    className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Email address"
                    required
                  />
                </div>
                {/* Password input */}
                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    value={input.password}
                    name="password"
                    type="password"
                    className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Password"
                    required
                  />
                </div>
                <div className="flex float-right items-center mb-6">
                  <Link
                    to="/register"
                    className="font-medium text-blue-600 hover:text-blue-700 focus:text-blue-700 active:text-blue-800 duration-200 transition ease-in-out"
                  >
                    Register Akun?
                  </Link>
                </div>
                {/* Submit button */}
                <button
                  type="submit"
                  className="inline-block px-7 py-3 bg-blue-600 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out w-full"
                  data-mdb-ripple="true"
                  data-mdb-ripple-color="light"
                >
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Login;
